import {  FormControl, FormHelperText, InputLabel, OutlinedInput, SelectChangeEvent } from '@mui/material'
import { FunctionComponent, useContext, useEffect, useState } from 'react'
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import PartnerService from '../../../shared/services/partner/partner.service'
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';
import LocationService from '../../../shared/services/location/location.service';
import { ICountry } from '../../../shared/services/location/location.model';

export const PartnerAddClientDialog: FunctionComponent<{
  open: boolean,
  closeHandler: () => void,
  successHandler: () => void,
}> = ({
  open,
  closeHandler,
  successHandler,
}) => {
    //Service
    const partnerService = new PartnerService()
    const locationService = LocationService.getInstance();
    //Context
    const userNotificationsContext = useContext(UserNotificationsContext)
    //State
    const [countries, setCountries] = useState<ICountry[]>([]);
    const [errorMessage, setErrorMessage] = useState<string>('')
    const [errorCode, setErrorCode] = useState<number>()
    //Loading State
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

    useEffect(() => {
      locationService.getAllCountries()
        .then(response => {
          setCountries(response)
        })
        .catch(err => {
          console.log(err)
        })
    }, [])

    const addClientSchema = Yup.object().shape({
      organisationName: Yup.string().required('Organisation name is required'),
      countryId: Yup.string().required('Please select the country where the organisation is headquartered.'),
    })
    const formik = useFormik<any>({
      initialValues: {
        organisationName: '',
        countryId: 'GBR',
      },
      validationSchema: addClientSchema,
      onSubmit: (values) => {
        setIsSubmitting(true)
        partnerService.createClient(values)
          .then(response => {
            successHandler()
            setIsSubmitting(false)
            userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' })
          })
          .catch(err => {
            setIsSubmitting(false)
            console.log(err)
            if (err?.response?.data?.message) {
              setErrorMessage(err.response.data.message)
              setErrorCode(err.response.data.code)
            } else {
              userNotificationsContext.openSnackbar({ open: true, message: 'There was an error creating the client, please try again', backgroundColor: 'text.primary' });
            }
          })
      }
    })

    // const selectCountryHandler = (e: SelectChangeEvent<ICountry | null>, value: ICountry | null) => {
    //   if (value) {
    //     formik.setValues({ ...formik.values, countryId: value.id })
    //   }
    // }


    const cancelHandler = () => {
      closeHandler()
      formik.resetForm()
      setErrorMessage('')
      setErrorCode(undefined)
    }

    return (
      <DialogWrapper open={open} onClose={closeHandler} title="Add Client" cancelHandler={cancelHandler} submitHandler={formik.submitForm} isSubmitting={isSubmitting}>
        <FormControl fullWidth variant='outlined' sx={{ mt: 1 }}>
          <InputLabel htmlFor='organisationName'>Organisation or Business Name</InputLabel>
          <OutlinedInput inputProps={{ min: 0 }} id='organisationName' label='Organisation or Business Name' name='organisationName' type='text'
            value={formik.values.organisationName}
            onChange={formik.handleChange}
            error={formik.touched.organisationName && Boolean(formik.errors.organisationName)}
            sx={{ color: 'text.primary' }}></OutlinedInput>
          {formik.touched.organisationName && formik.errors.organisationName &&
            <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>{formik.errors.organisationName as string}</FormHelperText>
          }
          {errorCode === 1 &&
            <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>{errorMessage}
            </FormHelperText>
          }
        </FormControl>
        {/* {countries &&
          <FormControl fullWidth variant='outlined' sx={{ mt: 2 }}>
            <Autocomplete
              id="countryId"
              options={countries.slice().sort((a, b) => (a.name === 'United Kingdom' ? -1 : b.name === 'United Kingdom' ? 1 : a.name.localeCompare(b.name)))}
              sx={{
                color: 'text.primary'
              }}
              getOptionLabel={(option) => `${option.name}`}
              renderOption={(props, option) => {
                const { key, ...restProps } = props as { key: React.Key } & React.HTMLAttributes<HTMLLIElement>;
                return (
                  <Box
                    component="li"
                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                    key={key}
                    {...restProps}
                  >
                    <img
                      loading="lazy"
                      width="20"
                      src={option.imageUrl}
                      alt="country flag"
                    />
                    {option.name}
                  </Box>
                )
              }}
              value={countries?.find(country => country.id === formik.values.countryId) || null}
              onChange={(e: any, value: ICountry | null) => selectCountryHandler(e, value)}
              renderInput={(params) => (
                <TextField
                  label='Country'
                  {...params}
                  error={formik.touched.countryId && Boolean(formik.errors.countryId)}
                />
              )}
            />
            {formik.touched.countryId && formik.errors.countryId &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {formik.errors.countryId ? <div>{formik.errors.countryId as string}</div> : null}
              </FormHelperText>
            }
            {errorCode === 8 &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>{errorMessage}
              </FormHelperText>
            }
          </FormControl>} */}
      </DialogWrapper>

    )
  }